exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".A7ZP-cmpL8O0UqETtSq3Z{font-size:0.6rem;margin-right:1rem}\n", ""]);

// exports
exports.locals = {
	"successMessageWrapper": "A7ZP-cmpL8O0UqETtSq3Z"
};